import React from 'react';
import { FiArrowRight, FiCrosshair } from 'react-icons/fi';
import PageHero from '../../fx/PageHero';

const Hero = () => {
    return (
        <PageHero
            pill="ADVERSARY EMULATION"
            title={[
                { text: 'Professional' },
                { text: 'Red Team', gradient: true },
                { text: 'services.' },
            ]}
            desc="Comprehensive red teaming, vulnerability assessment, and penetration testing for organizations of all sizes. We find what your attackers will, before they do."
            actions={[
                { label: 'Start assessment', primary: true, icon: <FiArrowRight />, to: '#contact', onClick: (e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); } },
                { label: 'Explore services', icon: <FiCrosshair />, to: '#services', onClick: (e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); } },
            ]}
        />
    );
};

export default Hero;
